module.exports = __webpack_public_path__ + "img/splicing_pop_defeate.84fdf887.png";